import constant from "../constant";

const initialState = {
  blocked: false,
  message: "",
};

const appBlocked = (state = initialState, action) => {
  switch (action.type) {
    case constant.UPDATE_BLOCKED_APP_STATUS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



export default appBlocked;